import {project2BaseUrl } from './remoteClient';

/**
 * Get job postings with match percentage
 * @param {string} token - Authorization token
 * @param {URLSearchParams} params - Query parameters
 * 
 * Expected params:
 * - userId: number (Required)
 * - city: string (Optional - exact match)
 * - state: string (Optional - exact match)
 * - title: string (Optional - partial match)
 * - company: string (Optional - partial match)
 * - page: number (Optional, default: 0, 0-based pagination!)
 * - size: number (Optional, default: 100)
 */
export async function getJobsRequest(token, params){
    
        return await project2BaseUrl.get(`/jobPost/getJobPostingsWithMatch?${params.toString()}`,{
            headers: {
                "Authorization": 'Bearer ' + token
            }
        })
    }

export async function addJobRequest(token, jobData){
         return await project2BaseUrl.post('/jobPost/addJob',jobData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
}

export async function updateJobRequest(token, jobData){

        return await project2BaseUrl.post('/jobPost/editJob',jobData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
}

export async function jobSkillRequest(token, jobPostingId){
        return await project2BaseUrl.get(`/jobPost/getJobPostingSkills?jobPostingId=${jobPostingId}`,{
            headers: {
                Authorization: `Bearer ${token}`
        }});
}

